import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';
import { IMyAttendences } from '../..';
import { cancelar } from '../../../../services/atendimentos';
import dateFormatToBR from '../../../../utils/dateFormat';
import getCookie from '../../../../utils/getCookies';

export interface SimpleDialogProps {
  open: boolean;
  attendence: IMyAttendences;
  handleClose: () => void;
}

const useStyles = makeStyles(() => ({
  boxHeader: {
    backgroundColor: '#E53535',
  },
  textName: {
    fontSize: '24px',
    lineHeight: '24px',
    letterSpacing: '0.1px',
  },
  textCpf: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'capitalize',
  },
  textNumberCounter: {
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '24px',
    letterSpacing: '0.1px',
  },
  textCounter: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '24px',
    textTansform: 'uppercase',
  },
  textUnidade: {
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '23px',
    textTransform: 'capitalize',
    color: '#737B7D',
    paddingBottom: '20px',
    paddingTop: '20px',
  },
  textService: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '22px',
    color: '#373F41',
  },
  textOrgan: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#373F41',
    paddingBottom: '20px',
  },
  textDateTime: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#373F41',
  },
  textTicket: {
    paddingTop: '20px',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#373F41',
    paddingBottom: '20px',
  },
  btnConfirm: {
    backgroundColor: '#3CD278',
    border: 'none',
    color: '#FFFFFF',
    borderRadius: '0',
    padding: '10px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#00a04b',
    },
  },
  btnClose: {
    backgroundColor: '#b0bec5',
    border: 'none',
    color: '#FFFFFF',
    borderRadius: '0',
    padding: '10px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#808e95',
    },
  },
}));

export default function CancelDialog({
  open,
  handleClose,
  attendence,
}: SimpleDialogProps) {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();

  const handleCancel = async (id: string) => {
    const token: string | null = getCookie('gov_access_token_sso');

    setLoading(true);
    if (token) {
      try {
        const { data } = await cancelar(token, id);
        setLoading(false);
        if (data) {
          handleClose();
          history.go(0);
        }
      } catch (err) {
        setLoading(false);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth
    >
      <DialogTitle id='alert-dialog-title' className={classes.boxHeader}>
        <Typography className={classes.textName}>
          Deseja cancelar o agendamento?
        </Typography>
      </DialogTitle>
      <DialogContent style={{ borderRadius: '0' }}>
        <DialogContentText>
          <Grid container>
            <Grid item style={{ paddingBottom: '20px' }}>
              <Typography className={classes.textUnidade}>
                {attendence.unidade.nome.toLowerCase()}
              </Typography>
              <Typography className={classes.textService}>
                {attendence.servico.titulo}
              </Typography>

              <Typography className={classes.textOrgan}>
                {`Órgão: ${attendence.orgao_responsavel}`}
              </Typography>

              <Typography className={classes.textDateTime}>
                Data da solicitação:
                <Typography component='strong'>
                  {' '}
                  {` ${
                    dateFormatToBR(attendence.created_at, true).split(' ')[0]
                  }`}
                </Typography>
              </Typography>

              <Typography className={classes.textDateTime}>
                Horário da solicitação:
                <Typography component='strong'>
                  {' '}
                  {` ${dateFormatToBR(attendence.created_at, true)
                    .split(' ')[1]
                    .slice(0, 5)}`}
                </Typography>
              </Typography>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {loading ? (
          <Box
            marginBottom='60px'
            width='100%'
            display='flex'
            justifyContent='center'
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Button
              variant='contained'
              color='primary'
              className={classes.btnConfirm}
              onClick={() => handleCancel(attendence.id)}
            >
              Sim, eu quero cancelar
            </Button>
            <Button
              onClick={handleClose}
              variant='contained'
              color='primary'
              className={classes.btnClose}
            >
              Não, eu não quero cancelar
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
